import {
  MultiSelect as RawMultiSelect,
  MultiSelectProps as RawMultiSelectProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import React from 'react';
import { useController } from 'react-hook-form';

export interface MultiSelectInputProps extends RawMultiSelectProps {
  type: 'multi-select';
  name: string;
}

export default function MultiSelectInput(props: MultiSelectInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    placeholder,
    type,
    error,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;
  const _placeholder = React.useMemo(() => {
    const hasValue = (field.value || []).length > 0;
    if (_disabled) return undefined;
    if (hasValue) return undefined;
    return placeholder;
  }, [_disabled, field.value, placeholder]);

  const withAsterisk = React.useMemo(() => {
    if (_disabled) return false;
    if (rest.required || rest.withAsterisk) return true;
  }, [_disabled, rest.required, rest.withAsterisk]);

  return (
    <RawMultiSelect
      {...rest}
      {...field}
      placeholder={_placeholder}
      type={type}
      value={field.value}
      onChange={(value) => {
        field.onChange(value);
        onChange?.(value);
      }}
      disabled={_disabled}
      error={_error}
      withAsterisk={withAsterisk}
    />
  );
}
